import { render, staticRenderFns } from "./RedirectDevice.vue?vue&type=template&id=8cddec3a&"
import script from "./RedirectDevice.vue?vue&type=script&lang=js&"
export * from "./RedirectDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports